import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'components/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PWAPrompt from 'react-ios-pwa-prompt';
import { Loader } from 'components/LoadingHOC';
import { connect } from 'react-redux';
import { analyticsSelector, userRecordSelector } from 'redux/selectors';
import { getAppLinks } from 'redux/actions';
import { getCurrentLocale } from 'lib/i18n-service';
import * as _ from 'lib/utilities';

const logAppStoreVisitEvent = (afterPath) => () => {
    _.mixpanelTrack('Web to App Store Visit');
    setTimeout(() => (window.location.href = afterPath),50);
}

class GetAppButtonsCore extends React.Component {
    render() {
        const currentLocale = getCurrentLocale();

        return (
            <div className="get-app-btns">
                <a href={this.playStoreLink()} onClick={logAppStoreVisitEvent(this.playStoreLink())}>
                    <img alt="Get it on Google Play" src={`https://play.google.com/intl/en_us/badges/images/generic/${currentLocale}_badge_web_generic.png`} className={`${currentLocale}-loc`}/>
                </a>
                <a href={this.appStoreLink()} className="app-store" onClick={logAppStoreVisitEvent(this.appStoreLink())}>
                    <img alt="Download on the App Store" src={`https://d2jbk7d41q2u2w.cloudfront.net/ios_badges/${currentLocale}/black.svg`} className={`${currentLocale}-loc`}/>
                </a>
            </div>
        )
    }

    appStoreLink = () => {
        const { analytics: { originalSource, originalCampaign, originalKeyword }={}, responseData: { linkInfo: { ios, override} } } = this.props;
        if(!_.isBlank(originalSource) && !override) {
            return `https://app.appsflyer.com/id1326334081?pid=${originalSource}&c=${originalCampaign || ''}&af_ad=${originalKeyword || ''}`
        } else {
            return ios;
        }
    }

    playStoreLink = () => {
        const { analytics: { originalSource, originalCampaign, originalKeyword }={}, responseData: { linkInfo: { android, override} } } = this.props;
        if(!_.isBlank(originalSource) && !override) {
            return `https://app.appsflyer.com/com.strongrfastr.cordova?pid=${originalSource}&c=${originalCampaign || ''}}&af_ad=${originalKeyword || ''}`
        } else {
            return android;
        }
    }
}

const GetPwaButton = ({ finishCallback }) => {
    const { t } = useTranslation();
    const [showPwaPrompt,setShowPwaPrompt] = useState(false);

    return (
        <React.Fragment>
            <div className="text-center pt30">
                <Button color="blue" rounded noShadow className="no-upcase" onClick={() => {
                    if(window.pwaInstallPromptEvent) {
                        window.pwaInstallPromptEvent.userChoice.then(() => (finishCallback && finishCallback()))
                        window.pwaInstallPromptEvent.prompt();
                    } else {
                        setShowPwaPrompt(true);
                    }
                }}>
                    <FontAwesomeIcon icon={['far','download']} /> {t('Install the App')}
                </Button>
            </div>
            {showPwaPrompt && (<PWAPrompt
                timesToShow={99999}
                delay={0}
                onClose={() => (finishCallback && finishCallback())}
                copyTitle={t('Install the App')}
                copyBody={t('aths description')}
                copyAddHomeButtonLabel={`2) ${t('aths instruction')}`}
                copyClosePrompt={t('Dismiss')}
                permanentlyHideOnDismiss={false}
            />)}
        </React.Fragment>
    )
}

class GetAppButtons extends React.Component {

    render() {
        const { getAppLinks, finishCallback, ...rest} = this.props;

        if(_.getAppPromptType() === 'pwa') {
            return (
                <GetPwaButton finishCallback={finishCallback} />
            )
        }

        return (
            <Loader
                successComponent={GetAppButtonsCore}
                type="blank"
                load={getAppLinks}
                preloaded={() => false}
                {...rest}
            />
        )
    }

}

const mapGaStateToProps = (state) => ({
    analytics: analyticsSelector(state),
    user: userRecordSelector(state)
})

const mapDispatchToGaProps = dispatch => ({
    getAppLinks: () => dispatch(getAppLinks())
})

export default connect(mapGaStateToProps,mapDispatchToGaProps)(GetAppButtons);
